import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import FlowDemo from './pages/FlowDemo';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/try-on" element={<FlowDemo />} />
        <Route path="/try-flow" element={<Navigate to="/try-on" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
